import { trackEcommerce } from "./core";
import { IItemTrackingParameters } from "./interfaces/IItemTrackingParameters";
import { getTrackingInfoForProduct } from "./api/globalTrackingApiService";
import { trackingEventNames } from "../../settings/constants";
import {
	createEcommerceSectionFromItemTrackingParameters,
	buildEcommerceSectionFromItemListTrackingParameters,
} from "./utils";
import IListNameAndId from "./interfaces/IListNameAndId";
import { IHasTrackingParameters } from "./interfaces/IHasTrackingParameters";
import { TrackingProperties } from "./types/TrackingProperties";

export async function track_view_item(code: string) {
	const trackingParameters: IItemTrackingParameters | null =
		await getTrackingInfoForProduct(code);
	if (trackingParameters == null) {
		return;
	}
	const event = {
		event: trackingEventNames.VIEW_ITEM,
		...createEcommerceSectionFromItemTrackingParameters(trackingParameters),
	};
	trackEcommerce(event);
}

export function track_view_item_list({
	productsDto,
	observedProducts,
	itemListIdAndName,
}: {
	productsDto: IHasTrackingParameters;
	observedProducts: Array<IHasTrackingParameters>;
	itemListIdAndName: IListNameAndId;
}) {
	const event = {
		event: trackingEventNames.VIEW_ITEM_LIST,
		...buildEcommerceSectionFromItemListTrackingParameters({
			productsDto,
			observedProducts,
			itemListIdAndName,
		}),
	};

	trackEcommerce(event);
}

export function track_select_item(
	ecommerceTrackingParameters: TrackingProperties,
	productDto: IHasTrackingParameters,
	listNameAndId: IListNameAndId
) {
	const event = {
		event: trackingEventNames.SELECT_ITEM,
		ecommerce: {
			...ecommerceTrackingParameters,
			...listNameAndId,
			items: [
				productDto?.globalTrackingParameters,
			]
		}
	};
	trackEcommerce(event);
}
